import React, { memo } from 'react';
import type { WithBlockRuntimeStateProps, WithBlockStateProps } from '../types';
import { useBlockRuntimeData, useRuntimeBlockKey } from '../../BlockRuntimeStateProvider/context';

export const withBlockRuntimeState = (
  WrappedComponent: React.ComponentType<WithBlockStateProps>,
) => {
  function WithBlockRuntimeStateWrapper(props: WithBlockRuntimeStateProps) {
    const { block, ...restProps } = props;

    const { data: blocksRuntimeState } = useBlockRuntimeData();
    const runtimeBlockKey = useRuntimeBlockKey();

    return (
      <WrappedComponent
        {...restProps}
        block={block}
        blocksRuntimeState={blocksRuntimeState}
        runtimeBlockKey={runtimeBlockKey}
      />
    );
  }

  return memo(WithBlockRuntimeStateWrapper);
};
